import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    counterView: {
      alignItems: 'center',
      borderRadius: '2px',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      marginLeft: 'auto',
      maxWidth: '25%',
      minWidth: '25%',
    },
    image: {
      borderRadius: '50%',
      height: '96%',
    },
    root: {
      flexGrow: 1,
      overflow: 'hidden',
    },
    gridIContainer: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    gridItem: {
      alignSelf: 'center',
    },
    gridTypography: {
      paddingLeft: theme.spacing(1),
      // margin: theme.spacing(0),
    },
    listView: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },

    paperAvatar: {
      display: 'flex',
      marginRight: '1vw',
    },
    paperName: {
      display: 'flex',
      alignItems: 'left',
    },
    paperMoodColor: {
      display: 'flex',
      alignItems: 'right',
      height: '35px',
      width: '100%',
    },
    typographyCountMood: {
      alignItems: 'right',
      alignSelf: 'center',
      color: 'white',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      textAlign: 'center',
      width: '100%',
    },
    value: {
      fontSize: '1.3em',
      fontWeight: 'bold',
      margin: '0 0 0 1vw',
      color: colors.textGrey3e,
      opacity: 0.8,
    },
    wrapper: {
      alignItems: 'center',
      border: `0.5px solid ${colors.greyBg}`,
      cursor: 'pointer',
      borderLeft: '0',
      borderRight: '0',
      borderRadius: '2px',
      color: colors.textGrey3e,
      display: 'flex',
      flexDirection: 'row',
      height: '6vh',
      justifyContent: 'left',
      marginTop: '-1px',
      width: '100%',
      // [theme.breakpoints.down('768')]: {
      //   height: '4vh',
      // },
    },
  })
);
